/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_Bookings_DescriptionInputs */

const en_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easily manage bookings from your calendar`)
};

const de_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte Buchungen ganz einfach über deinen Kalender`)
};

const es_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona fácilmente las reservas desde tu calendario`)
};

const fr_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez facilement les réservations à partir de votre calendrier`)
};

const nl_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer reserveringen eenvoudig via je kalender`)
};

const it_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci facilmente le prenotazioni dal tuo calendario`)
};

const pt_br2_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie facilmente reservas do seu calendário`)
};

const pl_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łatwo zarządzaj rezerwacjami z kalendarza`)
};

const hu_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könnyen kezelheti a foglalásokat naptárából`)
};

const ro_admin_dashboard_empty_bookings_description = /** @type {(inputs: Admin_Dashboard_Empty_Bookings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionati usor rezervarile din calendarul dumneavoastra`)
};

/**
* | output |
* | --- |
* | "Easily manage bookings from your calendar" |
*
* @param {Admin_Dashboard_Empty_Bookings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_bookings_description = /** @type {((inputs?: Admin_Dashboard_Empty_Bookings_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_Bookings_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_bookings_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_bookings_description(inputs)
	return ro_admin_dashboard_empty_bookings_description(inputs)
});
export { admin_dashboard_empty_bookings_description as "admin.dashboard.empty_bookings_description" }